/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Параметры согласия
 */
export interface AdvertisingAgreement {
  /** Телефон */
  phone?: string[];

  /** Почта */
  email?: string[];

  /** если Клиент установил галку «Соглашаюсь получать рекламу от Банка» */
  bankAdvertising?: boolean;

  /** если Клиент установил галку «Соглашаюсь получать рекламу от партнеров Банка» */
  bankPartnersAdvertising?: boolean;

  /** Текст */
  text1?: string;

  /** Текст */
  text2?: string;

  /** Подпись */
  signature?: string;
}

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Пусто ok-ответ
 */
export type EmptyResponse = object;

/**
 * ККБ платежного документа
 */
export interface CcbDocument {
  fields?: CcbDocumentFields;

  /** Тип документа */
  type?: DocumentType;
}

export type CcbDocumentFields = object;

/**
 * Получение ккб конкретного документа
 */
export interface DocumentCcbResponse {
  /** Документ ККБ */
  ccb?: string;

  /** Версия ККБ */
  ccbVersion?: string;

  /** ККБ платежного документа */
  document?: CcbDocument;
}

/**
 * Тип документа
 */
export interface DocumentType {
  name?: string;
  desc?: string;
}

/**
 * Параметры показа согласия
 */
export interface AdvertisingAgreementView {
  /** Показать ли согласие */
  needShow?: boolean;

  /**
   * Дата следующей проверки
   * @format date
   */
  nextCheck?: string;

  /** Телефон */
  phone?: string[];

  /** Почта */
  email?: string[];

  /** если Клиент установил галку «Соглашаюсь получать рекламу от Банка» */
  bankAdvertising?: boolean;

  /** если Клиент установил галку «Соглашаюсь получать рекламу от партнеров Банка» */
  bankPartnersAdvertising?: boolean;

  /** Фио подписанта */
  signatoryFio?: string;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-agreements
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-agreements.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Клиентские ресты для согласий
     * @name SaveAdvertisingAgreement
     * @summary Сохранение согласия
     * @request POST:/api/agreements/v1/external/agreements/save
     */
    saveAdvertisingAgreement: (
      data: AdvertisingAgreement,
      params: RequestParams = {}
    ) =>
      this.request<string, GenericError>({
        path: `/api/agreements/v1/external/agreements/save`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Клиентские ресты для согласий
     * @name CloseAdvertisingAgreement
     * @summary Сохранение согласия
     * @request POST:/api/agreements/v1/external/agreements/close
     */
    closeAdvertisingAgreement: (params: RequestParams = {}) =>
      this.request<EmptyResponse, GenericError>({
        path: `/api/agreements/v1/external/agreements/close`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Клиентские ресты для согласий
     * @name CheckAdvertisingAgreement
     * @summary Проверка согласия
     * @request GET:/api/agreements/v1/external/agreements/check
     */
    checkAdvertisingAgreement: (params: RequestParams = {}) =>
      this.request<boolean, GenericError>({
        path: `/api/agreements/v1/external/agreements/check`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Клиентские ресты для согласий
     * @name GetDocumentCcb
     * @summary Получение ккб согласия на рекламу
     * @request GET:/api/agreements/v1/external/agreements/ccb
     * @secure
     */
    getDocumentCcb: (
      query: { documentId: string },
      params: RequestParams = {}
    ) =>
      this.request<DocumentCcbResponse, GenericError>({
        path: `/api/agreements/v1/external/agreements/ccb`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Клиентские ресты для согласий
     * @name GetAdvertisingAgreement
     * @summary Получение согласия
     * @request GET:/api/agreements/v1/external/agreements/advertising
     */
    getAdvertisingAgreement: (params: RequestParams = {}) =>
      this.request<AdvertisingAgreementView, GenericError>({
        path: `/api/agreements/v1/external/agreements/advertising`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
